"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var FieldSanitizer_1 = require("../sanitizers/FieldSanitizer");
var valueComparator_1 = require("../valueComparator");
var makeField = function (WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.onChange$ = new rxjs_1.Subject();
            _this.subscription = O.none;
            _this.onChange = function (valueInput, dataInput) {
                if (_this.props.disabled) {
                    return;
                }
                var value = _this.sanitizer.format(_this.sanitizer.blockUnallowedCharacters(valueInput));
                _this.setState({ value: value });
                _this.onChange$.next({ value: value, data: dataInput });
            };
            _this.sanitizer = new FieldSanitizer_1.FieldSanitizer(_this.props.type);
            _this.state = {
                value: _this.sanitizer.format(_this.props.value),
            };
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            var _this = this;
            this.subscription = O.some(this.onChange$
                .pipe((0, operators_1.debounceTime)((0, function_1.pipe)(O.fromNullable(this.props.debounceTime), O.getOrElse(function () { return 0; }))))
                .subscribe(function (debounced) { return _this.props.onChange && _this.props.onChange(debounced.value, debounced.data); }));
        };
        class_1.prototype.componentWillUnmount = function () {
            (0, function_1.pipe)(this.subscription, O.chain(function (s) {
                s.unsubscribe();
                return O.none;
            }));
        };
        class_1.prototype.componentDidUpdate = function (prevProp) {
            if (!(0, valueComparator_1.isEqual)(prevProp.value, this.props.value) &&
                !(0, valueComparator_1.isEqual)(this.props.value, this.sanitizer.sanitize(this.state.value))) {
                this.setState({ value: this.sanitizer.format(this.props.value) });
            }
        };
        class_1.prototype.render = function () {
            return ((0, jsx_runtime_1.jsx)(WrappedComponent, __assign({}, Object.assign({}, this.props, { value: this.state.value, onChange: this.onChange }))));
        };
        return class_1;
    }(React.PureComponent));
};
exports.makeField = makeField;
//# sourceMappingURL=fieldMaker.js.map